import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceJobber = (props) => {

    const ClientId = "f41781f8-325a-4977-8932-caf719e0b5bd"
    const Scope = ""
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2" //https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2
    const AuthUrl = "https://api.getjobber.com/api/oauth/authorize?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&redirect_uri=" + RedirectUrl

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/jobber/tokens" OnOAuthPollResult={null} OnSetReady={props.OnSetReady}/>
}

DatasourceJobber.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceJobber